import React from 'react';
// template components
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// native components
import AdvisorConnectCardSimplified from '../../../../components/advisorConnectCardSimplified';

export default () => {
  return (
    <AdvisorConnectCardSimplified
      id='retirement-planning'
      advisorImageVariant='advisorB'
      headingText={<>Get your plan <WidowBlock>for retirement</WidowBlock></>}
      text='Our advisors will design your retirement plan based on your priorities and goals, tailoring it from a wide range of financial options including investment and insurance strategies, so you can retire when you want, the way you want.'
    />
  );
};
